import { usePrompt } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import { Button, FAIcon } from '@/components'
import { DownloadTachoFilesPrompt } from './download-tacho-files-prompt'
import type { DownloadTachoFilesMode } from './types'

interface DownloadTachoFilesButtonProps {
  mode: DownloadTachoFilesMode
}

export const DownloadTachoFilesButton: React.FC<
  DownloadTachoFilesButtonProps
> = ({ mode }) => {
  const translations = useTranslate({
    button: 'activities.download-multiple.button',
  })

  const addPrompt = usePrompt()

  async function handleClick() {
    await addPrompt<null>(resolve => (
      <DownloadTachoFilesPrompt mode={mode} onClose={() => resolve(null)} />
    ))
  }

  return (
    <Button variant="outline" size="lg" onClick={handleClick}>
      <FAIcon icon="download" />
      {translations.button}
    </Button>
  )
}
